/**
 * Created by tofael on 7/13/17.
 */
import React from 'react';

import Schedules from './schedule';
import Photo from '../photo-component';
import SipCredentials from './sip-credentials';
import Actions from './doctor-actions-component';
import DoctorForm from '../../shared/doctor-form';

const Profile = (props) => {
  let {
    fields, submitSchedule, locked, setScheduleFormDate, onStatusChange, showAlert, operatingHours,startTime, endTime,comment,status,
    submitStatusUpdate, statusOptions, handleCommentChange, onChange, showImage, deleteSchedule,toggleSipDialog,scheduleDate,sipId, sipPassword,
    handleSipCredsChange, updateSipCredentials, handleChange, onCheck, onSelectSpeciality, handleSubmit, isLoading, onPhotoSelect, schedules, available_specialities, sipDialogOpen, imagePreviewSrc
  } = props;

  return (
    <div>
      <div className="row">
        <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-md m-b-15">
          <Photo
            name={fields.name}
            showImage={showImage}
            locked={locked}
            status={status}
            photoUrl={imagePreviewSrc}/>
          <Actions
            fields={fields}
            comment={comment}
            status={status}
            locked={locked}
            onStatusChange={onStatusChange}
            handleCommentChange={handleCommentChange}
            statusOptions={statusOptions}
            submitStatusUpdate={submitStatusUpdate}
            toggleSipDialog={toggleSipDialog}
            showAlert={showAlert}/>
        </div>

        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-md m-b-15">
            <DoctorForm
              handleChange={handleChange}
              onCheck={onCheck}
              handleSubmit={handleSubmit}
              isLoading={isLoading}
              onPhotoSelect={onPhotoSelect}
              state={fields}
              available_specialities={available_specialities}
              onSelectSpeciality={onSelectSpeciality}
            />
        </div>
        <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-md m-b-15">
          <Schedules
            scheduleDate={scheduleDate}
            start_time={startTime}
            end_time={endTime}
            onChange={onChange}
            setScheduleFormDate={setScheduleFormDate}
            operatingHours={operatingHours}
            submitSchedule={submitSchedule}
            schedules={schedules}
            showAlert={showAlert}
            deleteSchedule={deleteSchedule}/>
        </div>
      </div>
      <SipCredentials
        open={sipDialogOpen}
        sip_id={sipId}
        sip_password={sipPassword}
        onChange={handleSipCredsChange}
        onUpdate={updateSipCredentials}
        toggleSipDialog={toggleSipDialog}/>
    </div>
  )
}

export default Profile;


// WEBPACK FOOTER //
// ./src/screens/profile/doctor/index.js